var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticClass:"w-100",attrs:{"multiple":_vm.multiple,"placeholder":"Seleccionar"},model:{value:(_vm.seleccion),callback:function ($$v) {_vm.seleccion=$$v},expression:"seleccion"}},_vm._l((_vm.categorias),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nombre,"value":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }